export enum FIELDS {
  FORM = 'FORM_INFORMATION_2FA',
  PHONE = 'PHONE_2FA',
  CODE = 'CODE_2FA',
}

export interface DispatchProps {
  setHideModal: () => void
  activateSecureUserAccount: (body: any) => void
  activateConfirmSecureUserAccount: (code: any) => void
  disable2FAConfirm: (code: any) => void
}

export interface OwnProps {
  user: any
  step: number
  isDisable: boolean
}

export type Props = OwnProps & DispatchProps
